import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { ServicesGrid } from '../components/ServicesGrid';
import { AboutSection } from '../components/AboutSection';
import { FleetShowcase } from '../components/FleetShowcase';
import { SpecialOffers } from '../components/SpecialOffers';
import { BrandPartners } from '../components/BrandPartners';
import { ProjectGallery } from '../components/ProjectGallery';
import { ReviewsCarousel } from '../components/ReviewsCarousel';
import { ServiceAreas } from '../components/ServiceAreas';
import { FinancingTeaser } from '../components/FinancingTeaser';
import { ContactCTA } from '../components/ContactCTA';
import { FAQAccordion } from '../components/FAQAccordion';
export function HomePage() {
  const homeFAQs = [{
    question: 'Are you licensed and insured in Michigan?',
    answer: "Yes, Moceri Residential Services is a fully licensed builder in the state of Michigan and carries comprehensive liability and workers' compensation insurance to protect you and your property."
  }, {
    question: 'Do you offer free estimates?',
    answer: "Absolutely. We provide free, no-obligation roof inspections and estimates for all our exterior services. We'll assess your needs and provide a transparent, upfront quote."
  }, {
    question: 'What areas do you serve?',
    answer: 'Our primary service area is St. Clair County, followed by Macomb County and Oakland County. We are based in Harrison Township and regularly work in cities like Port Huron, Clinton Township, Troy, and surrounding communities.'
  }, {
    question: 'Do you handle insurance claims for storm damage?',
    answer: 'Yes, we have extensive experience working with insurance companies. If your roof or siding has been damaged by wind or hail, we can help document the damage and guide you through the claims process.'
  }, {
    question: 'Do you offer financing?',
    answer: 'Yes, we understand that exterior renovations are a significant investment. We offer flexible financing options to help make your project more affordable. Contact us to learn about current terms and availability.'
  }];
  return <div className="w-full" data-id="element-806">
      <HeroSection data-id="element-807" />
      <div className="md:pt-24" data-id="element-808">
        <TrustBar data-id="element-809" />
      </div>
      <ServicesGrid data-id="element-810" />
      <AboutSection data-id="element-811" />
      <FleetShowcase data-id="element-812" />
      <SpecialOffers data-id="element-813" />
      <BrandPartners data-id="element-814" />
      <ProjectGallery data-id="element-815" />
      <ReviewsCarousel data-id="element-816" />
      <ServiceAreas data-id="element-817" />
      <FinancingTeaser data-id="element-818" />

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50" data-id="element-819">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-820">
          <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-821">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-822">
              Frequently Asked Questions
            </h2>
            <div className="w-20 h-1 bg-brand-blue mx-auto mb-6 rounded-full" data-id="element-823"></div>
            <p className="font-body text-brand-gray text-lg" data-id="element-824">
              Find answers to common questions about our services, process, and
              service areas.
            </p>
          </div>
          <FAQAccordion items={homeFAQs} data-id="element-825" />
        </div>
      </section>

      <ContactCTA data-id="element-826" />
    </div>;
}